import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import './resumerequest.css';

function ResumerequestDE({ onClose }) {
  const [formData, setFormData] = useState({
    email: '',
    Verification: '',
  });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('sending');

    emailjs.sendForm('default_service', 'template_bstvtn9', e.target, 'PRb_GDLhvtr54sgUl')
      .then((result) => {
        console.log(result.text);
        setStatus('success');
        setFormData({ email: '', Verification: '' });
        setTimeout(() => setStatus(null), 3000);
      }, (error) => {
        console.log(error.text);
        setStatus('error');
        setTimeout(() => setStatus(null), 3000);
      });
  };

  return (
    <div className="resume-popup-overlay">
      <div className="resume-popup">
        <button className="close-popup" onClick={onClose}>X</button>
        <h2>Lebenslauf & Zertifikate anfragen</h2>
        <p>Geben Sie hier Ihre E-Mail und Firmenwebseite an, um meinen Lebenslauf, Zeugnisse und Zertifikate innerhalb von 48 Stunden zu erhalten.</p>

        <form onSubmit={handleSubmit} id="resume-request-form">
          <div className="form-group">
            <label htmlFor="email">Ihre E-Mail Adresse</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Wo soll ich Ihnen antworten?"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="Verification">Link zu Ihrer Firma</label>
            <input
              type="text"
              id="Verification"
              name="Verification"
              value={formData.Verification}
              onChange={handleChange}
              placeholder="beispiel-firma.de"
              required
            />
          </div>

          <button 
            type="submit"
            className={status ? `status-${status}` : ''}
            disabled={status === 'sending'}
          >
            {status === 'sending' && 'Wird gesendet...'}
            {status === 'success' && 'Anfrage erhalten!'}
            {status === 'error' && 'Fehlgeschlagen! Bitte erneut versuchen'}
            {!status && 'Lebenslauf anfragen'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ResumerequestDE;